import { Route, Routes } from "react-router";
import { HomePage } from "./pages/Homepage";
import { LoginPage } from "./pages/LoginPage";
import { ReportPage } from "./pages/ReportPage";
import { SubscriptionPage } from "./pages/SubscriptionPage";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Routes>
      {/* Routes pour les pages de connexion et de la page d'accueil */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/report" element={<ReportPage />} />
      <Route path="/subscription" element={<SubscriptionPage />} />
    </Routes>
  );
}

export default App;
